<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              class="navbar-brand"
              to="/"
            >
              <span class="brand-logo">
                <b-img
                  :src="isVerticalMenuCollapsed ? appLogoImage2 : appLogoImage"
                  :height="appLogoImage.includes('arasana') ? '30' : '96'"
                  alt="logo"
                />
              </span>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <!--          <li class="nav-item nav-toggle">-->
          <!--            <b-link class="nav-link modern-nav-toggle">-->
          <!--              <feather-icon-->
          <!--                icon="XIcon"-->
          <!--                size="20"-->
          <!--                class="d-block d-xl-none"-->
          <!--                @click="toggleVerticalMenuActive"-->
          <!--              />-->
          <!--              <feather-icon-->
          <!--                :icon="collapseTogglerIconFeather"-->
          <!--                size="20"-->
          <!--                class="d-none d-xl-block collapse-toggle-icon"-->
          <!--                @click="toggleCollapsed"-->
          <!--              />-->
          <!--            </b-link>-->
          <!--          </li>-->
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      v-if="false"
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
<!--      <header-credits />-->
      <vertical-nav-menu-items
        :items="menuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import navMenuItems from '@/navigation/vertical'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import store from '@/store'
import HeaderCredits from '@core/layouts/components/app-navbar/components/HeaderCredits.vue'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    HeaderCredits,
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    const menuItems = computed(() => {
      // eslint-disable-next-line no-underscore-dangle
      let _menuItems = navMenuItems

      _menuItems = _menuItems.map(item => {
        if (item.route !== 'chat') return item

        const unreadChatCount = store.getters['socket/unreadChatCount']
        return {
          ...item,
          tag: unreadChatCount > 99 ? '99+' : unreadChatCount,
          tagVariant: 'danger',
        }
      })

      if (store.getters['auth/userGender'] === 'female') {
        if (!store.getters['auth/freeCallUser']) {
          _menuItems = _menuItems
          // .filter(item => item.route !== 'market')
            .filter(item => item.route !== 'account-status')
            .filter(item => item.route !== 'gains')
            .filter(item => item.route !== 'cashouts')
            .filter(item => item.route !== 'rewards')
        }
      } else {
        _menuItems = _menuItems.filter(item => item.route !== 'gains')
          .filter(item => item.route !== 'account-status')
          .filter(item => item.route !== 'cashouts')
          .filter(item => item.route !== 'rewards')
          // .filter(item => item.route !== 'new-users')
          .filter(item => item.route !== 'online-users')
      }
      if (!store.getters['auth/userCanStartVideoCall']) {
        _menuItems = _menuItems
          .filter(item => item.route !== 'video-call-users')
      }

      return _menuItems
    })

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: true,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImage, appLogoImage2 } = $themeConfig.app

    return {
      navMenuItems,
      menuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
      appLogoImage2,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
